import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";

const LanguageChange = () => {
  const [cookies, setCookie] = useCookies();
  const location = useLocation();

  // Add Google Translate script dynamically
  const addGoogleTranslateScript = () => {
    const existingScript = document.querySelector(
      'script[src*="translate_a/element.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    } else {
      console.log("Google Translate script already exists.");
    }
  };

  // Initialize Google Translate widget
  const googleTranslateElementInit = () => {
    console.log("Initializing Google Translate Widget...");

    const userLang = navigator.language || "en";
    document.cookie = `googtrans=/en/${userLang};path=/;max-age=604800;`;

    if (cookies?.googtrans) {
      const splitLang = cookies.googtrans.split("/");
      setCookie("googtrans", `/en/${splitLang[2]}`, {
        path: "/",
        maxAge: 604800,
      });
    }

    if (window.google && window.google.translate) {
      new window.google.translate.TranslateElement(
        {
          includedLanguages: "en,hi,bn,te,mr,ur",
          layout: "google.translate.TranslateElement.InlineLayout.SIMPLE",
        },
        "google_translate_element"
      );
    } else {
      console.error("Google Translate API is not loaded.");
    }
  };

  useEffect(() => {
    // Assign the widget initialization function to the global window object
    window.googleTranslateElementInit = googleTranslateElementInit;

    // Add the Google Translate script
    addGoogleTranslateScript();

    // Clean up on component unmount
    return () => {
      const script = document.querySelector(
        'script[src*="translate_a/element.js"]'
      );
      if (script) {
        document.body.removeChild(script);
      }

      const translateContainer = document.getElementById(
        "google_translate_element"
      );
      if (translateContainer) translateContainer.innerHTML = ""; // Clear the widget
    };
  }, [location.pathname]); // Reinitialize on route changes

  return (
    <div className="language-option">
      <div id="google_translate_element" />
    </div>
  );
};

export default LanguageChange;
